import { registerLeadFilterSection } from "@/features/leads/components/leadFilter/registry";
import {
  LEAD_FILTER_INDUSTRY_IDS,
  PREFERENCE_KEYWORDS_BY_INDUSTRY,
} from "@/features/leads/components/leadFilter/config/leadFilterIndustryConfig";
import AcademyPreferences from "@/features/leads/components/leadFilter/components/Preferences/AcademyPreferences";

registerLeadFilterSection({
  id: "preference",
  industryIds: [LEAD_FILTER_INDUSTRY_IDS.ACADEMY],
  title: "Program Preferences",
  searchKeywords:
    PREFERENCE_KEYWORDS_BY_INDUSTRY[LEAD_FILTER_INDUSTRY_IDS.ACADEMY],
  render: () => <AcademyPreferences />,
});
